import { supabase } from '../lib/supabase';

const CACHE_TTL_MS = 5 * 60 * 1000;
let cache = { at: 0, map: null };


export async function getAppSettingsMap() {
  const now = Date.now();
  if (cache.map && now - cache.at < CACHE_TTL_MS) {
    return cache.map;
  }

  try {
    const { data, error } = await supabase
      .from('app_settings')
      .select('key, value');

    if (error) {
      console.warn('app_settings indisponible:', error.message);
      cache = { at: now, map: {} };
      return cache.map;
    }

    const map = {};
    (data || []).forEach((row) => {
      if (row?.key) map[row.key] = row.value ?? '';
    });
    cache = { at: now, map };
    return map;
  } catch (err) {
    console.warn('app_settings exception:', err);
    cache = { at: now, map: {} };
    return cache.map;
  }
}

export async function getAppSetting(key) {
  const map = await getAppSettingsMap();
  const value = map?.[key];
  return String(value).trim();
}

export async function getBrandName() {
  return getAppSetting('MARQUE');
}

export async function getContactEmail() {
  return getAppSetting('CONTACT_EMAIL');
}

export async function getContactPhone() {
  return getAppSetting('CONTACT_PHONE');
}


export async function getLoginUrl() {
  return getAppSetting('LOGIN_URL');
  
}

export function clearAppSettingsCache() {
  cache = { at: 0, map: null };
}
